import App from 'app/app.js';

var HOME_UNAUTHENTICATED = 'home-unauthenticated';
var ADD_ONS_LISTING = 'add-ons-listing';
var PRODUCT_NAME = '{productName}';
var PRODUCTNAME_EDIT = '{productName}-edit';
var BILLING_INFO = 'billing-info';
var CREATE_ACCOUNT = 'create-account';
var CREATE_YOUR_OWN = 'create-your-own';
var CREATE_YOUR_OWN_EDIT = 'create-your-own-edit';
var MY_ACCOUNT = 'my-account';
var DID_ERROR = 'did-error';
var DOWNLOADS = 'downloads';
var DSSK_ERROR_UNDEFINED = 'dssk-error-undefined';
var ENHANCED_PAY_ONLY = 'enhanced-pay-only';
var ENHANCED_PAY_ONLY_EDIT = 'enhanced-pay-only-edit';
var ENTER_PASSWORD = 'enter-password';
var EVENT_LIST = 'event-list';
var EXPLAINER = 'explainer';
var FIND_MY_PICTURE_DAY = 'find-my-picture-day';
var LOGIN = 'login';
var MYFAMILY_REWARDS_ROUTETO = 'myfamily-rewards-enrollment';
var ORDER_DETAIL = 'order-detail';
var ORDER_HISTORY = 'order-history';
var COMPLETE = 'complete';
var PRODUCTNAME_DETAIL = '{productName}-detail';
var PRODUCTNAME_EDIT = '{productName}-edit';
var PACKAGES_LISTING = 'packages-listing';
var PASSWORD_RECOVERY = 'password-recovery';
var PASSWORD_RECOVERY_GUEST = 'password-recovery-guest';
var PAY_ONLY = 'pay-only';
var PAYMENT_INFO = 'payment-info';
var PICTURE_DAY = 'picture-day';
var PICTUREDAY_ID = 'pictureday-ID';
var DESC = '[desc]';
var PREPAY_STUDENT_INFO = 'prepay-student-info';
var RESET_PASSWORD = 'reset-password';
var REVIEW_ORDER = 'review-order';
var SAFETY = 'safety';
var SAFETY_CONFIRMATION = 'safety-confirmation';
var SAFETY_DOWNLOAD = 'safety-download';
var SAFETY_RECEIPT = 'safety-receipt';
var SCHOOL_FINDER = 'school-finder';
var CART_VIEW = 'cart-view';
var SPECIAL_OFFERS = 'bundle-deals';
var STUDENT_ID_INFO = 'student-id-info';
var SUGGESTED_PRODUCTS = 'suggested-products';
var SWITCH_ACCOUNT = 'switch-account';
var TAX_INFO = 'tax-info';
var PRODUCTNAME_TEXT = '{productName}-text';
var PRODUCTNAME_BUNDLE = '{productName}-bundle';
var PRODUCTNAME_CYOP = '{productName}-cyop';
var PRODUCTNAME_ADDON = '{productName}-addon';
var PRODUCTNAME_PACKAGE = '{productName}-package';
var PRODUCTNAME_ADDON_EDIT = '{productName}-addon-edit';
var PRODUCTNAME_BUNDLE_EDIT = '{productName}-bundle-edit';
var PRODUCTNAME_CYOP_EDIT = '{productName}-cyop-edit';
var PRODUCTNAME_PACKAGE_EDIT = '{productName}-package-edit';
var WE_FOUND_A_MATCH = 'we-found-a-match';
var ORDER_STATUS_LOOKUP = 'order-status-lookup';
var MY_PROOFS = 'we-found-a-match';
var MY_DASHBOARD = 'my-dashboard';
var I_DONT_HAVE_CODE = 'i-dont-have-code';

var PageNameConstants = {
  '/': HOME_UNAUTHENTICATED,
  '/accessCredentials/:identifier/:accessCode': HOME_UNAUTHENTICATED,
  '/addon': ADD_ONS_LISTING,
  '/addon-detail/:skuCode': PRODUCT_NAME,
  '/addon-detail/edit/:editIndex': PRODUCTNAME_EDIT,
  '/billing-info': BILLING_INFO,
  '/bundle-detail/:skuCode': PRODUCT_NAME,
  '/bundle-detail/edit/:editIndex': PRODUCTNAME_EDIT,
  '/create-account': CREATE_ACCOUNT,
  '/cyop': CREATE_YOUR_OWN,
  '/cyop/edit/:editIndex': CREATE_YOUR_OWN_EDIT,
  '/my-account/': MY_ACCOUNT,
  '/didError/:identifier': DID_ERROR,
  '/downloads': DOWNLOADS,
  '/downloads/:identifier': DOWNLOADS,
  '/dsskError/:identifier': DSSK_ERROR_UNDEFINED,
  '/enhanced-pay-only': ENHANCED_PAY_ONLY,
  '/enhanced-pay-only/edit/:editIndex': ENHANCED_PAY_ONLY_EDIT,
  '/enter-password': ENTER_PASSWORD,
  '/event-list': EVENT_LIST,
  '/explainer': EXPLAINER,
  '/findmypictureday': FIND_MY_PICTURE_DAY,
  '/login': LOGIN,
  '/myfamily-rewards-enrollment/:routeTo': MYFAMILY_REWARDS_ROUTETO,
  '/order-detail/:orderId': ORDER_DETAIL,
  '/order-history/': ORDER_HISTORY,
  '/order-receipt': COMPLETE,
  '/package-detail/:skuCode': PRODUCTNAME_DETAIL,
  '/package-detail/edit/:editIndex': PRODUCTNAME_EDIT,
  '/packages': PACKAGES_LISTING,
  '/password-recovery': PASSWORD_RECOVERY,
  '/password-recovery/guestAccount': PASSWORD_RECOVERY_GUEST,
  '/password-recovery/setPasswordForGuest': PASSWORD_RECOVERY_GUEST,
  '/pay-only': PAY_ONLY,
  '/payment-info': PAYMENT_INFO,
  '/picture-day': PICTURE_DAY,
  '/pictureDayId/:identifier': PICTUREDAY_ID,
  '/portrait-looks/:desc': PRODUCT_NAME,
  '/portrait-looks/:desc/:fromPage': PRODUCT_NAME,
  '/prepay-student-info': PREPAY_STUDENT_INFO,
  '/reset-password': RESET_PASSWORD,
  '/review-order': REVIEW_ORDER,
  '/safety': SAFETY,
  '/safety/:identifier': SAFETY,
  '/safety-confirmation': SAFETY_CONFIRMATION,
  '/safety-download': SAFETY_DOWNLOAD,
  '/safety-receipt': SAFETY_RECEIPT,
  '/school-finder': SCHOOL_FINDER,
  '/shopping-cart': CART_VIEW,
  '/bundle-deals': SPECIAL_OFFERS,
  '/student-id-info': STUDENT_ID_INFO,
  '/suggestedProducts': SUGGESTED_PRODUCTS,
  '/switch-account': SWITCH_ACCOUNT,
  '/taxInfo': TAX_INFO,
  '/textPersonalizer/addon/:skuCode': PRODUCTNAME_ADDON,
  '/textPersonalizer/bundle/:skuCode': PRODUCTNAME_BUNDLE,
  '/textPersonalizer/cyop/:skuCode': PRODUCTNAME_CYOP,
  '/textPersonalizer/edit/addon/:skuCode/:editIndex': PRODUCTNAME_ADDON_EDIT,
  '/textPersonalizer/edit/bundle/:skuCode/:editIndex': PRODUCTNAME_BUNDLE_EDIT,
  '/textPersonalizer/edit/cyop/:skuCode/:editIndex': PRODUCTNAME_CYOP_EDIT,
  '/textPersonalizer/edit/package/:skuCode/:editIndex': PRODUCTNAME_PACKAGE_EDIT,
  '/textPersonalizer/package/:skuCode': PRODUCTNAME_PACKAGE,
  '/we-found-a-match': WE_FOUND_A_MATCH,
  '/we-found-a-match:studentIdPath': WE_FOUND_A_MATCH,
  '/order-status-lookup': ORDER_STATUS_LOOKUP,
  '/my-proofs': MY_PROOFS,
  '/my-dashboard': MY_DASHBOARD,
  '/i-dont-have-code': I_DONT_HAVE_CODE
};
App.constant('PageNameConstants', PageNameConstants);
